/**
 * Embed a Ask Us Chat block in a page.
 * Used as part of the AskChatTab component.
 */
import React from 'react';
import { useEffect } from 'react';
import * as styles from 'src/uglib_styles/askChat.module.css'
 
function inject_launch_button() {

    var chats = document.getElementsByClassName('libraryh3lp');
    Array.prototype.forEach.call(chats, function(el) {
        if (el.dataset.lh3Jid && !el.querySelector('.ug-launch-chat')) {
            var sr_button_text = document.createElement("span");
            sr_button_text.setAttribute("class", "sr-only");
            sr_button_text.append('Opens in new browser window.');

            var button = document.createElement("button");
            button.append("Start Chat");
            button.append(sr_button_text);
            button.setAttribute("class", "btn btn-primary ug-launch-chat");
            button.setAttribute("onclick", "window.open('https://ca.libraryh3lp.com/chat/guelph@chat.ca.libraryh3lp.com?lang=en&skin=15611', 'AskUs', 'resizable=1,width=375,height=350'); return false;");
            el.append(button);
        }
    });
}


function AskChat (props) {
    useEffect(()  => {
        if (!window.jabber_user) {
            var x = document.createElement("script"); x.type = "text/javascript"; x.async = true;
            x.src = (document.location.protocol === "https:" ? "https://" : "http://") + "ca.libraryh3lp.com/js/libraryh3lp.js?514";
            var y = document.getElementsByTagName("script")[0]; y.parentNode.insertBefore(x, y);

            setTimeout(inject_launch_button, 1000); 
        }
    });

    return (<>
        <div className={styles.ask_chat_wrapper}> 
            <div className="needs-js">chat loading...</div>
            <ul>
                <li>Ask Chat is a <a href="https://ask.scholarsportal.info/">collaborative service</a></li>
                <li><a href="https://www.lib.uoguelph.ca/service-hours">Ask Us Online Chat hours</a></li>
                <li><a href="https://www.lib.uoguelph.ca/contact-us">Contact Us</a></li>
            </ul>
        </div>
    </>);
     
}
 
export default AskChat